module.exports = __webpack_public_path__ + "img/kommune-1243.e1eee585.svg";